import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreateService } from "../../../hooks/services/useCreateService";

const DefaultServicesSeederDialog = ({ open = false, setOpen, successCallback }) => {

    const { t } = useTranslation('common');

    const defaultData = [
        {name: "General Consultation Fee", description: "Standard charge for a routine visit and initial evaluation of a pet's health."},
        {name: "Check-up Fee ", description: "Cost for a scheduled wellness exam to monitor ongoing health and preventive care."},
        {name: "Comprehensive Exam Fee", description: "Fee for a detailed, full-body assessment including history, diagnostics, and treatment planning."},
        {name: "Vaccination Fee", description: "Charge for administering vaccines to protect pets against infectious diseases."},
        {name: "Emergency Consultation Fee", description: "Higher fee applied for urgent, unscheduled visits requiring immediate attention."},
        {name: "Critical Care Fee", description: "Cost for intensive monitoring and life-support treatment of severely ill or injured pets."},
        {name: "Neuter Fee", description: "Surgical fee for sterilizing male pets to prevent reproduction and reduce health risks."},
        {name: "Soft Tissue Surgery", description: "Charge for procedures involving internal organs, skin, or non-bone structures."},
        {name: "Orthopedic Surgery", description: "Fee for surgical treatment of bones, joints, or musculoskeletal injuries."},
        {name: "Grooming Fee", description: "Cost for professional cleaning, trimming, and maintenance of a pet's coat and hygiene."}
    ];
    
    const handleClose = (event, reason) => {
        // Prevent closing when clicking the backdrop or pressing Escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
        }
        setOpen(false);
    };

    const { create } = useCreateService(successCallback);

    const onConfirm = () => {
        createDefaultData();
        setOpen(false);
    }

    const createDefaultData = async () => {
        await create(defaultData);
    };

    return (
        <Dialog open={open} onClose={handleClose} disableRestoreFocus>
                <DialogTitle>
                    Services Inital Setup...
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        The system has created a default set of Services. 
                        <br /><br />
                        Set the price of each service and customize the list by going to the Services Price List Maintenance page.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={onConfirm}
                    color="primary"
                    >
                    Got it
                    </Button>
                </DialogActions>
        </Dialog>
  );
};

export default DefaultServicesSeederDialog;